module.exports = "/* <![CDATA[ */\r\n{{fontString}}\r\n/* ]]> */"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/font-styles/font-styles.component.html
// module id = ./src/app/shared/font-styles/font-styles.component.html
// module chunks = main